<template>
    <div class="modal fade" :id="''+modalId" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <form @submit.prevent="submitData" class="form">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ !isEdit ? $t('appointment_types.creation') : $t('appointment_types.modification') }}</h5>
                        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal" aria-label="Close">
                            <span class="svg-icon svg-icon-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                                        fill="currentColor"/>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                                        fill="currentColor"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div class="modal-body">
                        <RequiredText />
                        <Input
                            containerClass="col-12 mt-2 mb-5"
                            :name="`${id}-name`"
                            type="text"
                            :label="$t('appointment_types.name')"
                            labelClass="form-label"
                            :inputClass="'form-control form-control-lg form-control-solid'"
                            :placeholder="$t('appointment_types.name')"
                            :isRequired="true" size="lg"
                            v-model="formData.name"
                        />
                    </div>
                    <div class="modal-footer">
                        <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
                        <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoadingType"></Button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>

    import {ref, defineProps} from 'vue'
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText"
    import Button from "@/components/Button.vue"
    import Input from "@/components/Input.vue";

    const store = useStore()

    const props = defineProps({
        form: { 
            type: Object, 
            default: {
                name: ''
            } 
        },
        id: {
            type: String,
            required: true
        },
        parent: {
            type: String,
            required: false
        },
        isEdit: {
            type: Boolean,
            required: false
        }
    })

    const emits = defineEmits(['load', 'addType','reloadDatatable'])

    const modalId = ref(props.id)

    const formData = ref(props.form)
    const isLoadingType = ref(false)

    function submitData(){
        if(!props.isEdit){
            createAppointmentTypeData()
        }else{
            updateAppointmentTypeData()
        }
    }

    function closeModal(){
        if(parent){
            $('#'+props.parent).modal('toggle')
        }
        $('#'+modalId.value).modal('toggle')
    }

    function createAppointmentTypeData() {
        isLoadingType.value = true
        store.dispatch('appointmentTypes/createAppointmentType', formData.value)
            .then((response) => {
                emits('addType', response.data?.data?.id)
                emits('load')
                isLoadingType.value = false
                closeModal()
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.appointment_type_created'))
            })
            .catch(err => {
                isLoadingType.value = false
            })
    }

    function updateAppointmentTypeData() {
        isLoadingType.value = true
        store.dispatch('appointmentTypes/updateAppointmentType', formData.value)
            .then((response) => {
                emits('load')
                emits('reloadDatatable')
                isLoadingType.value = false
                closeModal()
                formData.value.id = ''
                formData.value.name = ''
                window.toastr['success'](i18n.global.t('notification.appointment_type_updated'))
            })
            .catch(err => {
                isLoadingType.value = false
            })
    }
</script>